import { render, staticRenderFns } from "./DCanvas.vue?vue&type=template&id=390da76e&scoped=true&"
import script from "./DCanvas.vue?vue&type=script&lang=js&"
export * from "./DCanvas.vue?vue&type=script&lang=js&"
import style0 from "./DCanvas.vue?vue&type=style&index=0&id=390da76e&scoped=true&lang=scss&"
import style1 from "./DCanvas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390da76e",
  null
  
)

export default component.exports